import { useState } from "react";
import { Input } from "@/components/ui/input";

export const EXPENSE_CATEGORIES = ["Handyman", "Packing Material", "Local Transportation", "Delivery Labour", "Packing Labour", "Damage Claim"];

export function ExpenseCategoryField({ value, onChange, testid = "expense-category", className = "h-9" }) {
  const [other, setOther] = useState(!!value && !EXPENSE_CATEGORIES.includes(value));
  const pick = (v) => {
    if (v === "__other__") { setOther(true); onChange(""); return; }
    setOther(false); onChange(v);
  };
  return (
    <div className="space-y-1.5">
      <select className={`rounded-none w-full bg-card border border-border px-2 text-sm ${className}`} value={other ? "__other__" : (value || "")} onChange={(e) => pick(e.target.value)} data-testid={testid}>
        <option value="">Select category…</option>
        {EXPENSE_CATEGORIES.map((c) => <option key={c} value={c}>{c}</option>)}
        <option value="__other__">Other</option>
      </select>
      {other && <Input className={`rounded-none bg-card ${className}`} value={value} onChange={(e) => onChange(e.target.value)} placeholder="Enter custom category" data-testid={`${testid}-other`} />}
    </div>
  );
}
